import { useEffect } from "react";

import { isMiniApp } from "../auth";

/** Однократная инициализация Telegram WebApp + применение цветовой схемы. */
export function useTelegramApp() {
  useEffect(() => {
    const root = document.documentElement;

    // Веб-версия (вне Telegram): тема по системным настройкам, без themeParams.
    if (!isMiniApp()) {
      const prefersDark =
        typeof window !== "undefined" &&
        window.matchMedia?.("(prefers-color-scheme: dark)").matches;
      root.dataset.theme = prefersDark ? "dark" : "light";
      return;
    }

    const tg = window.Telegram?.WebApp;
    if (!tg) return;
    tg.ready();
    tg.expand();

    root.dataset.theme = tg.colorScheme;
    // tg.themeParams содержит CSS-цвета (bg_color, text_color, ...).
    for (const [key, value] of Object.entries(tg.themeParams ?? {})) {
      root.style.setProperty(`--tg-${key.replace(/_/g, "-")}`, value);
    }
  }, []);
}
